<template>
    <div class="workordrAssign">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>向指挥中心申请退回
        </div>
        <div class="workordr_content">
            <el-form label-width="120px"
                     :model="ruleForm"
                     :rules="rules"
                     label-position="left"
                     ref="ruleFormRef"
            >
                <div class="workordr_main">
                    <div>
                        <el-form-item label="退回原因" prop="czCzjgwb">
                            <el-input maxlength="2000" :autosize="{ minRows: 5}" v-model="ruleForm.czCzjgwb" show-word-limit type="textarea"/>
                        </el-form-item>
                        <Workorder_file @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>
                        <!--<div class="workordr_footer">-->
                            <!--<div class="workordr_footer_zpcbdw">-->
                                <!--转派承办单位-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <el-popconfirm
                        title="确认提交指挥中心吗？"
                        @confirm="confirmEvent(ruleFormRef)"
                    >
                        <template #reference>
                            <div class="workordrAssign_btn_sure">
                                确认
                            </div>
                        </template>
                    </el-popconfirm>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance} from 'vue'
    import {ElMessageBox,ElLoading} from 'element-plus'
    import {useStore} from 'vuex';
    import Workorder_file from './Wordorder_file.vue';

    export default {
        name: "Workorder_SQTH",
        props: ["gdId","thqx"],
        components: {
            Workorder_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": 'GDTH',
                "gdId": props.gdId,
                "czCzjgwb": "",
                "fileIds":[],
            });
            const rules = reactive({
                czThlx: [
                    {required: true, message: "请选择退回类型", trigger: 'blur'},
                ],
                czCzjgwb: [
                    {required: true, message: "请输入退回原因", trigger: 'blur'},
                ]
            });
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent");
                                        store.state.addNewWorkorderSuccess=true;
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            let thlxSelectData =ref({
            });
            //取消事件
            const cancleClick=()=>{
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             if(props.thqx=="1"){
                //                 proxy.$axios.post("/jgfast/wgsj/gdcz", {
                //                     "czCzlx": 'SQTH',
                //                     "gdId": props.gdId,
                //                     "czCzjgzt": "0",
                //                     "czThlx": "",
                //                     "czCzjgwb": "",
                //                 }).then((res) => {
                //                     context.emit("workorderCancle","1");
                //                 });
                //             }else{
                //                 context.emit("workorderCancle");
                //             }
                //         }
                //     },
                // })
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
                context.emit("workorderCancle");
            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            const confirmEvent =(param)=>{
                submitForm(param)
            }
            onMounted(() => {
                proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                    "codeTable":"cdg_thlx"
                }).then((res) => {
                    thlxSelectData.value = res.data;
                });
            });
            return {
                ruleForm,
                rules,
                ruleFormRef,
                thlxSelectData,
                cancleClick,
                fileListToParent,
                deleteFile,
                confirmEvent
            }
        }
    }
</script>

<style scoped>

</style>
